var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 2.66663H7.99984C5.05432 2.66663 2.6665 5.05444 2.6665 7.99996V24C2.6665 26.9455 5.05432 29.3333 7.99984 29.3333H23.9998C26.9454 29.3333 29.3332 26.9455 29.3332 24V13.3333M25.3332 2.66663V10.6666M29.3332 6.66663L21.3332 6.66663M29.3332 18.6666L25.4145 15.8452C23.3782 14.3791 20.5954 14.5306 18.7304 16.2091L13.2693 21.1241C11.4043 22.8026 8.62143 22.9542 6.58518 21.4881L2.6665 18.6666M14.6665 11.3333C14.6665 13.1742 13.1741 14.6666 11.3332 14.6666C9.49222 14.6666 7.99984 13.1742 7.99984 11.3333C7.99984 9.49234 9.49222 7.99996 11.3332 7.99996C13.1741 7.99996 14.6665 9.49234 14.6665 11.3333Z",
    stroke: "#2247C0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAdd);
export default __webpack_public_path__ + "static/media/image-add.6d2eef409ab21dbd1fc67e575c33e4e5.svg";
export { ForwardRef as ReactComponent };